import { render } from "./CognitiveAnalysis.vue?vue&type=template&id=395750a5&scoped=true"
import script from "./CognitiveAnalysis.vue?vue&type=script&lang=js"
export * from "./CognitiveAnalysis.vue?vue&type=script&lang=js"

import "./CognitiveAnalysis.vue?vue&type=style&index=0&id=395750a5&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395750a5"]])

export default __exports__